import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NavbarService {
    private mobileMenuOpened = false;
    private obs$ = new BehaviorSubject(this.mobileMenuOpened);

    onMobileMenuClosed(): Observable<boolean> {
        return this.obs$.asObservable().pipe(filter(s => s === false));
    }

    onMobileMenuOpened(): Observable<boolean> {
        return this.obs$.asObservable().pipe(filter(s => s === true));
    }

    openMobileMenu(): void {
        document.querySelector('.section-offscreen-menu').classList.add('-active');
        this.mobileMenuOpened = true;
        this.obs$.next(this.mobileMenuOpened);
    }

    closeMobileMenu(): void {
        document.querySelector('.section-offscreen-menu').classList.remove('-active');
        this.mobileMenuOpened = false;
        this.obs$.next(this.mobileMenuOpened);
    }

    get isMobileMenuOpened(): boolean {
        return this.mobileMenuOpened;
    }
}
